"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _rcSteps = _interopRequireDefault(require("rc-steps"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledSteps = require("./StyledSteps");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var YkbSteps = /*#__PURE__*/function (_Component) {
  function YkbSteps() {
    (0, _classCallCheck2.default)(this, YkbSteps);
    return _callSuper(this, YkbSteps, arguments);
  }
  (0, _inherits2.default)(YkbSteps, _Component);
  return (0, _createClass2.default)(YkbSteps, [{
    key: "render",
    value: function render() {
      var _this = this;
      return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/_react.default.createElement(_StyledSteps.StepsContainer, {
          theme: theme,
          prefixCls: _this.props.prefixCls
        }, function (styledPrefix) {
          return /*#__PURE__*/_react.default.createElement(_rcSteps.default, (0, _extends2.default)({
            icons: {
              error: /*#__PURE__*/_react.default.createElement(_Icon.default, {
                name: "exclamation"
              }),
              finish: /*#__PURE__*/_react.default.createElement(_Icon.default, {
                name: "check"
              })
            }
          }, _this.props, {
            prefixCls: styledPrefix
          }));
        });
      });
    }
  }]);
}(_react.Component);
(0, _defineProperty2.default)(YkbSteps, "Step", _rcSteps.default.Step);
YkbSteps.displayName = 'Steps';
YkbSteps.propTypes = {
  /**
   * Additional CSS ui classes
   */
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  prefixCls: _propTypes.default.string,
  labelPlacement: _propTypes.default.string,
  direction: _propTypes.default.oneOf(['horizontal', 'vertical']),
  current: _propTypes.default.number,
  status: _propTypes.default.oneOf(['error', 'process', 'finish', 'wait']),
  size: _propTypes.default.string
};
YkbSteps.defaultProps = {
  // prefixCls: 'ykb-steps',
  labelPlacement: 'vertical',
  direction: 'horizontal',
  current: 0,
  status: 'process',
  className: ''
};
var _default = exports.default = YkbSteps;